import { PARTNER_SLUG_MAX_LENGTH } from '../models';

export function toPartnerSlug(displayName: string): string {
  return displayName
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-{2,}/g, '-')
    .slice(0, PARTNER_SLUG_MAX_LENGTH)
    .replace(/^-|-$/g, '');
}
